import { Outlet, Navigate } from 'react-router-dom'
import { useActor } from '@xstate/react'
import { Header } from '../modules/Header/Header'
import { Footer } from '../modules/Footer/Footer'
import { AuthState } from '../xstate/auth.machine'
import { Loader } from '../modules/Loader/Loader'
import { PromptAccess } from '../modules/PromptAccess/PromptAccess'
import { useState } from 'react'

export function Account() {
	const [stateAuth, sendAuth] = useActor(AuthState)

	const handleAccept = () => {
		sendAuth({ type: 'allowPersonalData' })
	}

	return (
		<>
			{(stateAuth.matches('idle') ||
				stateAuth.matches('loading') ||
				stateAuth.context?.is_personal_data_storage_allowed === undefined) && (
				<div className='fullPageLoader'>
					<Loader />
				</div>
			)}
			{!stateAuth.context?.is_personal_data_storage_allowed &&
			stateAuth.matches('auth') ? (
				<>
					<PromptAccess
						fnAccept={() => handleAccept()}
						fnClose={() => sendAuth({ type: 'logout' })}
					/>
				</>
			) : (
				<>
					{stateAuth.matches('unAuth') && <Navigate replace to='/auth' />}
					<Header account />
					<Outlet />
					<Footer account />
				</>
			)}
		</>
	)
}
